import * as z from "zod/v4";

export const getSlackChannels = {
  name: "getSlackChannels" as const,
  input: z.object({
    showAllChannels: z.boolean().optional().default(false),
    forceRefresh: z.boolean().optional().default(false),
  }),
  output: z.object({
    channels: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        isExternal: z.boolean(),
        isPrivate: z.boolean(),
      }),
    ),
  }),
};
